// Simple Redux module for Client ATS
const LOAD_BRIEF = 'twineApp/clientATS/LOAD_BRIEF';
const LOAD_BRIEF_SUCCESS = 'twineApp/clientATS/LOAD_BRIEF_SUCCESS';
const LOAD_BRIEF_FAIL = 'twineApp/clientATS/LOAD_BRIEF_FAIL';

const UPDATE_BRIEF = 'twineApp/clientATS/UPDATE_BRIEF';
const UPDATE_BRIEF_SUCCESS = 'twineApp/clientATS/UPDATE_BRIEF_SUCCESS';
const UPDATE_BRIEF_FAIL = 'twineApp/clientATS/UPDATE_BRIEF_FAIL';

const LOAD_PITCHES = 'twineApp/clientATS/LOAD_PITCHES';
const LOAD_PITCHES_SUCCESS = 'twineApp/clientATS/LOAD_PITCHES_SUCCESS';
const LOAD_PITCHES_FAIL = 'twineApp/clientATS/LOAD_PITCHES_FAIL';

const REFRESH_PITCHES = 'twineApp/clientATS/REFRESH_PITCHES';
const REFRESH_PITCHES_SUCCESS = 'twineApp/clientATS/REFRESH_PITCHES_SUCCESS';
const REFRESH_PITCHES_FAIL = 'twineApp/clientATS/REFRESH_PITCHES_FAIL';

const MARK_PITCH_AS_READ = 'twineApp/clientATS/MARK_PITCH_AS_READ';
const MARK_PITCH_AS_READ_SUCCESS =
  'twineApp/clientATS/MARK_PITCH_AS_READ_SUCCESS';
const MARK_PITCH_AS_READ_FAIL = 'twineApp/clientATS/MARK_PITCH_AS_READ_FAIL';

const MARK_PITCH_THREAD_AS_READ =
  'twineApp/clientATS/MARK_PITCH_THREAD_AS_READ';
const MARK_PITCH_THREAD_AS_READ_SUCCESS =
  'twineApp/clientATS/MARK_PITCH_THREAD_AS_READ_SUCCESS';
const MARK_PITCH_THREAD_AS_READ_FAIL =
  'twineApp/clientATS/MARK_PITCH_THREAD_AS_READ_FAIL';

const DECLINE_PITCH = 'twineApp/clientATS/DECLINE_PITCH';
const DECLINE_PITCH_SUCCESS = 'twineApp/clientATS/DECLINE_PITCH_SUCCESS';
const DECLINE_PITCH_FAIL = 'twineApp/clientATS/DECLINE_PITCH_FAIL';

const SHORTLIST_PITCH = 'twineApp/clientATS/SHORTLIST_PITCH';
const SHORTLIST_PITCH_SUCCESS = 'twineApp/clientATS/SHORTLIST_PITCH_SUCCESS';
const SHORTLIST_PITCH_FAIL = 'twineApp/clientATS/SHORTLIST_PITCH_FAIL';

const REVIEW_PITCH = 'twineApp/clientATS/REVIEW_PITCH';
const REVIEW_PITCH_SUCCESS = 'twineApp/clientATS/REVIEW_PITCH_SUCCESS';
const REVIEW_PITCH_FAIL = 'twineApp/clientATS/REVIEW_PITCH_FAIL';

const LOAD_PITCH_MESSAGES = 'twineApp/clientATS/LOAD_PITCH_MESSAGES';
const LOAD_PITCH_MESSAGES_SUCCESS =
  'twineApp/clientATS/LOAD_PITCH_MESSAGES_SUCCESS';
const LOAD_PITCH_MESSAGES_FAIL = 'twineApp/clientATS/LOAD_PITCH_MESSAGES_FAIL';

const SEND_PITCH_MESSAGE = 'twineApp/clientATS/SEND_PITCH_MESSAGE';
const SEND_PITCH_MESSAGE_SUCCESS =
  'twineApp/clientATS/SEND_PITCH_MESSAGE_SUCCESS';
const SEND_PITCH_MESSAGE_FAIL = 'twineApp/clientATS/SEND_PITCH_MESSAGE_FAIL';

const END_HIRE = 'twineApp/clientATS/END_HIRE';
const END_HIRE_SUCCESS = 'twineApp/clientATS/END_HIRE_SUCCESS';
const END_HIRE_FAIL = 'twineApp/clientATS/END_HIRE_FAIL';

const RESET_PITCH = 'twineApp/clientATS/RESET_PITCH';
const RESET_PITCH_SUCCESS = 'twineApp/clientATS/RESET_PITCH_SUCCESS';
const RESET_PITCH_FAIL = 'twineApp/clientATS/RESET_PITCH_FAIL';

const ACCEPT_PITCH = 'twineApp/clientATS/ACCEPT_PITCH';
const ACCEPT_PITCH_SUCCESS = 'twineApp/clientATS/ACCEPT_PITCH_SUCCESS';
const ACCEPT_PITCH_FAIL = 'twineApp/clientATS/ACCEPT_PITCH_FAIL';

const LOAD_PUBLIC_QUESTIONS = 'twineApp/clientATS/LOAD_PUBLIC_QUESTIONS';
const LOAD_PUBLIC_QUESTIONS_SUCCESS =
  'twineApp/clientATS/LOAD_PUBLIC_QUESTIONS_SUCCESS';
const LOAD_PUBLIC_QUESTIONS_FAIL =
  'twineApp/clientATS/LOAD_PUBLIC_QUESTIONS_FAIL';

const ANSWER_PUBLIC_QUESTION = 'twineApp/clientATS/ANSWER_PUBLIC_QUESTION';
const ANSWER_PUBLIC_QUESTION_SUCCESS =
  'twineApp/clientATS/ANSWER_PUBLIC_QUESTION_SUCCESS';
const ANSWER_PUBLIC_QUESTION_FAIL =
  'twineApp/clientATS/ANSWER_PUBLIC_QUESTION_FAIL';

const initialState = {
  brief: null,
  pitches: [],
  loading: false,
  loadingPitches: false,
  pitchesLoaded: false,
  decliningPitch: false,
  shortlistingPitch: false,
  reviewingPitch: false,
  endingHire: false,
  resettingPitch: false,
  acceptingPitch: false,
  updatingBrief: false,
  pitchMessages: {},
  pitchMessagesMeta: {}, // Stores pagination metadata per pitch
  loadingPitchMessages: false,
  sendingMessage: false,
  markingThreadAsRead: false,
  markedThreads: {}, // Track which threads have been marked as read (by pitchId)
  publicQuestions: [],
  loadingPublicQuestions: false,
  publicQuestionsLoaded: false,
  answeringQuestion: false,
  error: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_BRIEF:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case LOAD_BRIEF_SUCCESS:
      return {
        ...state,
        brief: action.result,
        loading: false,
      };

    case LOAD_BRIEF_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case UPDATE_BRIEF:
      return {
        ...state,
        updatingBrief: true,
      };

    case UPDATE_BRIEF_SUCCESS:
      return {
        ...state,
        updatingBrief: false,
        brief: {
          ...state.brief,
          ...action.result,
        },
      };

    case UPDATE_BRIEF_FAIL:
      return {
        ...state,
        updatingBrief: false,
        error: action.error,
      };

    case LOAD_PITCHES:
      return {
        ...state,
        loadingPitches: true,
      };

    case LOAD_PITCHES_SUCCESS:
      return {
        ...state,
        pitches: action.result.messages || [],
        loadingPitches: false,
        pitchesLoaded: true,
      };

    case LOAD_PITCHES_FAIL:
      return {
        ...state,
        loadingPitches: false,
        pitchesLoaded: true,
        error: action.error,
      };

    case REFRESH_PITCHES:
      // Silent refresh - don't set loading state
      return state;

    case REFRESH_PITCHES_SUCCESS:
      return {
        ...state,
        pitches: action.result.messages || [],
        pitchesLoaded: true,
      };

    case REFRESH_PITCHES_FAIL:
      return {
        ...state,
        error: action.error,
      };

    case MARK_PITCH_AS_READ_SUCCESS:
      if (action.result?.skipped) {
        return {
          ...state,
        };
      }

      return {
        ...state,
        pitches: state.pitches.map((pitch) =>
          pitch.id === action.pitchId
            ? { ...pitch, receiver_viewed: true, has_unread_messages: false }
            : pitch
        ),
      };

    case MARK_PITCH_AS_READ_FAIL:
      return { ...state, error: action.error };

    case MARK_PITCH_THREAD_AS_READ:
      return {
        ...state,
        markingThreadAsRead: true,
      };

    case MARK_PITCH_THREAD_AS_READ_SUCCESS:
      if (action.result?.skipped) {
        return {
          ...state,
          markingThreadAsRead: false,
        };
      }

      return {
        ...state,
        markingThreadAsRead: false,
        markedThreads: {
          ...state.markedThreads,
          [action.pitchId]: true,
        },
        pitches: state.pitches.map((pitch) =>
          pitch.id === action.pitchId
            ? { ...pitch, has_unread_messages: false }
            : pitch
        ),
      };

    case MARK_PITCH_THREAD_AS_READ_FAIL:
      return {
        ...state,
        markingThreadAsRead: false,
        error: action.error,
      };

    case DECLINE_PITCH:
      return {
        ...state,
        decliningPitch: true,
      };

    case DECLINE_PITCH_SUCCESS:
      return {
        ...state,
        decliningPitch: false,
        pitches: state.pitches.map((pitch) =>
          pitch.id === action.pitchId
            ? { ...pitch, declined_at: new Date().toISOString() }
            : pitch
        ),
      };

    case DECLINE_PITCH_FAIL:
      return {
        ...state,
        decliningPitch: false,
        error: action.error,
      };

    case SHORTLIST_PITCH:
      return {
        ...state,
        shortlistingPitch: true,
      };

    case SHORTLIST_PITCH_SUCCESS:
      return {
        ...state,
        shortlistingPitch: false,
        pitches: state.pitches.map((pitch) =>
          pitch.id === action.pitchId
            ? { ...pitch, liked_at: new Date().toISOString() }
            : pitch
        ),
      };

    case SHORTLIST_PITCH_FAIL:
      return {
        ...state,
        shortlistingPitch: false,
        error: action.error,
      };

    case REVIEW_PITCH:
      return {
        ...state,
        reviewingPitch: true,
      };

    case REVIEW_PITCH_SUCCESS:
      return {
        ...state,
        reviewingPitch: false,
        pitches: state.pitches.map((pitch) =>
          pitch.id === action.pitchId
            ? { ...pitch, reviewed_at: new Date().toISOString() }
            : pitch
        ),
      };

    case REVIEW_PITCH_FAIL:
      return {
        ...state,
        reviewingPitch: false,
        error: action.error,
      };

    case LOAD_PITCH_MESSAGES:
      return {
        ...state,
        loadingPitchMessages: true,
      };

    case LOAD_PITCH_MESSAGES_SUCCESS: {
      const messageResult = action.result;
      const existingMessages = state.pitchMessages[action.pitchId] || [];
      const existingMeta = state.pitchMessagesMeta[action.pitchId] || {
        pagesLoaded: 0,
      };

      // Reverse new messages and prepend to existing (for pagination)
      const newMessages = (messageResult.messages || []).reverse();
      const allMessages = [...newMessages, ...existingMessages];

      return {
        ...state,
        loadingPitchMessages: false,
        pitchMessages: {
          ...state.pitchMessages,
          [action.pitchId]: allMessages,
        },
        pitchMessagesMeta: {
          ...state.pitchMessagesMeta,
          [action.pitchId]: {
            pagesLoaded: existingMeta.pagesLoaded + 1,
            more:
              messageResult.meta?.pagination?.current_page <
              messageResult.meta?.pagination?.total_pages,
          },
        },
      };
    }

    case LOAD_PITCH_MESSAGES_FAIL:
      return {
        ...state,
        loadingPitchMessages: false,
        error: action.error,
      };

    case SEND_PITCH_MESSAGE:
      return {
        ...state,
        sendingMessage: true,
      };

    case SEND_PITCH_MESSAGE_SUCCESS: {
      const { pitchId, message } = action;
      const existingMessages = state.pitchMessages[pitchId] || [];

      return {
        ...state,
        sendingMessage: false,
        pitchMessages: {
          ...state.pitchMessages,
          [pitchId]: [...existingMessages, message],
        },
      };
    }

    case SEND_PITCH_MESSAGE_FAIL:
      return {
        ...state,
        sendingMessage: false,
        error: action.error,
      };

    case END_HIRE:
      return {
        ...state,
        endingHire: true,
      };

    case END_HIRE_SUCCESS:
      return {
        ...state,
        endingHire: false,
        pitches: state.pitches.map((pitch) =>
          pitch.id === action.pitchId
            ? { ...pitch, completed_at: new Date().toISOString() }
            : pitch
        ),
      };

    case END_HIRE_FAIL:
      return {
        ...state,
        endingHire: false,
        error: action.error,
      };

    case RESET_PITCH:
      return {
        ...state,
        resettingPitch: true,
      };

    case RESET_PITCH_SUCCESS:
      return {
        ...state,
        resettingPitch: false,
        pitches: state.pitches.map((pitch) => {
          if (pitch.id === action.pitchId) {
            const updates = { liked_at: null, declined_at: null };
            // If moving to applied (resetReviewedDate=true), clear reviewed_at
            // If moving to reviewed (resetReviewedDate=false), set reviewed_at
            if (action.resetReviewedDate) {
              updates.reviewed_at = null;
            } else {
              updates.reviewed_at = new Date().toISOString();
            }
            return { ...pitch, ...updates };
          }
          return pitch;
        }),
      };

    case RESET_PITCH_FAIL:
      return {
        ...state,
        resettingPitch: false,
        error: action.error,
      };

    case ACCEPT_PITCH:
      return {
        ...state,
        acceptingPitch: true,
      };

    case ACCEPT_PITCH_SUCCESS:
      return {
        ...state,
        acceptingPitch: false,
        pitches: state.pitches.map((pitch) =>
          pitch.id === action.pitchId
            ? { ...pitch, accepted_at: new Date().toISOString() }
            : pitch
        ),
      };

    case ACCEPT_PITCH_FAIL:
      return {
        ...state,
        acceptingPitch: false,
        error: action.error,
      };

    case LOAD_PUBLIC_QUESTIONS:
      return {
        ...state,
        loadingPublicQuestions: true,
      };

    case LOAD_PUBLIC_QUESTIONS_SUCCESS:
      return {
        ...state,
        publicQuestions: action.result.public_questions || [],
        loadingPublicQuestions: false,
        publicQuestionsLoaded: true,
      };

    case LOAD_PUBLIC_QUESTIONS_FAIL:
      return {
        ...state,
        loadingPublicQuestions: false,
        publicQuestionsLoaded: true,
        error: action.error,
      };

    case ANSWER_PUBLIC_QUESTION:
      return {
        ...state,
        answeringQuestion: true,
      };

    case ANSWER_PUBLIC_QUESTION_SUCCESS:
      return {
        ...state,
        answeringQuestion: false,
        publicQuestions: state.publicQuestions.map((q) =>
          q.id === action.questionId
            ? {
                ...q,
                answer: action.answer,
                updated_at: new Date().toISOString(),
              }
            : q
        ),
      };

    case ANSWER_PUBLIC_QUESTION_FAIL:
      return {
        ...state,
        answeringQuestion: false,
        error: action.error,
      };

    default:
      return state;
  }
}

// Action creators
export function loadBrief(encodedId) {
  return {
    types: [LOAD_BRIEF, LOAD_BRIEF_SUCCESS, LOAD_BRIEF_FAIL],
    promise: (client) =>
      client.get(
        `/notices/collaboration/${encodedId}?include=user,user.avatars,invites,invites.user,invites.user.avatars,invites.user.skills,invites.user.tools`
      ),
  };
}

export function updateBrief(encodedId, payload) {
  return {
    types: [UPDATE_BRIEF, UPDATE_BRIEF_SUCCESS, UPDATE_BRIEF_FAIL],
    promise: (client) =>
      client.patch(`/notices/collaboration/${encodedId}`, {
        data: payload,
      }),
  };
}

export function loadPitches(briefId) {
  return {
    types: [LOAD_PITCHES, LOAD_PITCHES_SUCCESS, LOAD_PITCHES_FAIL],
    promise: (client) =>
      client.get(
        `/notices/collaboration/${briefId}/pitches?include=sender,sender.avatars,sender.skills,sender.tools,rating,sender.resume&paginator=100`
      ),
  };
}

export function refreshPitches(briefId) {
  return {
    types: [REFRESH_PITCHES, REFRESH_PITCHES_SUCCESS, REFRESH_PITCHES_FAIL],
    promise: (client) =>
      client.get(
        `/notices/collaboration/${briefId}/pitches?include=sender,sender.avatars,sender.skills,sender.tools,rating,sender.resume&paginator=100`
      ),
  };
}

export function markPitchAsRead(pitchId) {
  return {
    types: [
      MARK_PITCH_AS_READ,
      MARK_PITCH_AS_READ_SUCCESS,
      MARK_PITCH_AS_READ_FAIL,
    ],
    promise: (client) => client.patch(`/messages/viewed/${pitchId}`),
    pitchId,
  };
}

export function declinePitch(briefId, pitchId) {
  return {
    types: [DECLINE_PITCH, DECLINE_PITCH_SUCCESS, DECLINE_PITCH_FAIL],
    promise: (client) =>
      client.put(
        `/notices/collaboration/${briefId}/pitches/${pitchId}/decline`
      ),
    pitchId,
  };
}

export function shortlistPitch(briefId, pitchId) {
  return {
    types: [SHORTLIST_PITCH, SHORTLIST_PITCH_SUCCESS, SHORTLIST_PITCH_FAIL],
    promise: (client) =>
      client.put(`/notices/collaboration/${briefId}/pitches/${pitchId}/like`),
    pitchId,
  };
}

export function reviewPitch(briefId, pitchId) {
  return {
    types: [REVIEW_PITCH, REVIEW_PITCH_SUCCESS, REVIEW_PITCH_FAIL],
    promise: (client) =>
      client.put(`/notices/collaboration/${briefId}/pitches/${pitchId}/review`),
    pitchId,
  };
}

export function loadPitchMessages(
  username,
  pitchId,
  markAsRead = false,
  page = 1
) {
  return {
    types: [
      LOAD_PITCH_MESSAGES,
      LOAD_PITCH_MESSAGES_SUCCESS,
      LOAD_PITCH_MESSAGES_FAIL,
    ],
    promise: (client) =>
      client.get(
        `/threads/${username}?limit=20&page=${page}&mark_as_read=${+markAsRead}&include=message,sender,sender.avatars,receiver,receiver.avatars`
      ),
    pitchId,
  };
}

export function markPitchThreadAsRead(username, pitchId) {
  return {
    types: [
      MARK_PITCH_THREAD_AS_READ,
      MARK_PITCH_THREAD_AS_READ_SUCCESS,
      MARK_PITCH_THREAD_AS_READ_FAIL,
    ],
    promise: (client) => client.patch(`/threads/${username}/markAsRead`),
    pitchId,
  };
}

export function sendPitchMessage(
  recipient,
  messageText,
  pitchId,
  currentUserId
) {
  return {
    types: [
      SEND_PITCH_MESSAGE,
      SEND_PITCH_MESSAGE_SUCCESS,
      SEND_PITCH_MESSAGE_FAIL,
    ],
    promise: (client) =>
      client.post('/messages?include=user,message', {
        data: {
          message: messageText,
          receiver_id: recipient.id,
          type: 'private',
        },
      }),
    pitchId,
    message: {
      id: Date.now(),
      text: messageText,
      sender_id: currentUserId,
      receiver_id: recipient.id,
      timestamp: new Date().toISOString(),
      type: 'private',
      receiver_viewed: false,
    },
  };
}

export function endHire(briefId, pitchId) {
  return {
    types: [END_HIRE, END_HIRE_SUCCESS, END_HIRE_FAIL],
    promise: (client) =>
      client.put(`/notices/collaboration/${briefId}/pitches/${pitchId}/end`, {
        data: {},
      }),
    pitchId,
  };
}

export function resetPitch(briefId, pitchId, resetReviewedDate = true) {
  let params = '';
  if (!resetReviewedDate) {
    params += '?reset_reviewed_date=0';
  }

  return {
    types: [RESET_PITCH, RESET_PITCH_SUCCESS, RESET_PITCH_FAIL],
    promise: (client) =>
      client.put(
        `/notices/collaboration/${briefId}/pitches/${pitchId}/reset${params}`
      ),
    pitchId,
    resetReviewedDate,
  };
}

export function acceptPitch(briefId, pitchId) {
  return {
    types: [ACCEPT_PITCH, ACCEPT_PITCH_SUCCESS, ACCEPT_PITCH_FAIL],
    promise: (client) =>
      client.put(`/notices/collaboration/${briefId}/pitches/${pitchId}/accept`),
    pitchId,
  };
}

export function loadPublicQuestions(briefId) {
  return {
    types: [
      LOAD_PUBLIC_QUESTIONS,
      LOAD_PUBLIC_QUESTIONS_SUCCESS,
      LOAD_PUBLIC_QUESTIONS_FAIL,
    ],
    promise: (client) =>
      client.get(`/notices/collaboration/${briefId}/questions/public`),
  };
}

export function answerPublicQuestion(briefId, questionId, answer) {
  return {
    types: [
      ANSWER_PUBLIC_QUESTION,
      ANSWER_PUBLIC_QUESTION_SUCCESS,
      ANSWER_PUBLIC_QUESTION_FAIL,
    ],
    promise: (client) =>
      client.post(
        `/notices/collaboration/${briefId}/questions/public/${questionId}`,
        {
          data: {
            answer,
            _method: 'PATCH',
          },
        }
      ),
    questionId,
    answer,
  };
}
